module.exports = __webpack_public_path__ + "img/sence-zfwy.04998cb2.png";